import validate from "/var/www/html/node_modules/nuxt/dist/pages/runtime/validate.js";
import location_45reg_45flow_45hash_45global from "/var/www/html/middleware/location-reg-flow-hash.global.js";
import route_45global from "/var/www/html/middleware/route.global.js";
export const globalMiddleware = [
  validate,
  location_45reg_45flow_45hash_45global,
  route_45global
]
export const namedMiddleware = {
  blog: () => import("/var/www/html/middleware/blog.js"),
  page: () => import("/var/www/html/middleware/page.js")
}